import React, { useState } from 'react';
import { Form, Input, Button, Card, Row, Col, Typography } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import AxiosOICStat from '../AxiosOICStat';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const { Text } = Typography;

export const ForgotPassword = () => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const onFinish = async ({ email }) => {
    setLoading(true);
    try {
      const { data } = await AxiosOICStat.post(`/users/reset_password`, null, {
        params: { email },
      });

      if (data === true) {
        setSuccess(true);
        toast.success('Password reset successful. Redirecting to login...', { autoClose: 2000 });
        setTimeout(() => navigate('/login'), 2000);
      } else {
        toast.error('Unexpected response. Please try again later.');
      }
    } catch (err) {
      if (err?.response?.status === 404) {
        toast.error('User not found.');
      } else {
        toast.error('Unknown error. Please try again later.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Row
      style={{
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Col xs={24} sm={12} md={8} lg={6}>
        <Card
          title="Forgot Password"
          bordered={false}
          style={{
            boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
            width: '100%',
            maxWidth: 500,
          }}
        >
          {success ? (
            <div style={{ padding: '2rem 0', textAlign: 'center' }}>
              <CheckCircleOutlined style={{ color: '#52c41a', fontSize: '64px' }} />
              <div style={{ marginTop: '1rem' }}>
                <Text strong>Password reset successful!</Text>
                <br />
                <Text type="secondary">Redirecting to login...</Text>
              </div>
            </div>
          ) : (
            <Form layout="vertical" name="forgot_password" onFinish={onFinish}>
              <Form.Item
                name="email"
                rules={[
                  { required: true, message: 'Please input your Email!' },
                  { type: 'email', message: 'Please enter a valid email.' },
                ]}
              >
                <Input placeholder="Email" type="email" />
              </Form.Item>
              <Form.Item>
                <Button type="primary" htmlType="submit" block loading={loading}>
                  Submit
                </Button>
              </Form.Item>
              <div style={{ textAlign: 'center' }}>
                <Link to="/login">Back to Login</Link>
              </div>
            </Form>
          )}
        </Card>
      </Col>
    </Row>
  );
};
